function openCartDrawer() {
  document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  document.querySelector("body").classList.add("cart-drawer-open");
}
function closeCartDrawer() {
  document.querySelector(".cart-drawer").classList.remove("cart-drawer--active");
  document.querySelector("body").classList.remove("cart-drawer-open");
}
function updateCartItemCounts(count) {
  document.querySelectorAll(".cart-count").forEach((el) => {
    el.textContent = count;
  });
}
async function updateCartDrawer() {
  // MARKETS: use the locale-aware root so the drawer re-renders
  // in the visitor's market context (currency/prefix), not the default "/"
  const root = window.Shopify.routes.root;
  const res = await fetch(root + "?section_id=cart-drawer");
  const text = await res.text();
  const html = document.createElement("div");
  html.innerHTML = text;
  const newBox = html.querySelector(".cart-drawer").innerHTML;
  document.querySelector(".cart-drawer").innerHTML = newBox;
  addCartDrawerListeners();
}
function addCartDrawerListeners() {
  // Update quantities
  document
    .querySelectorAll(".cart-drawer .quantity-selector button.quantity-change")
    .forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem = button.parentElement.parentElement.parentElement.parentElement;
        const key = rootItem.getAttribute("data-line-item-key");
        // Get new quantity
        const currentQuantity = Number(
          button.parentElement.querySelector("input").value
        );
        const isUp = button.classList.contains("quantity-plus");
        const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;
        // Ajax update
        // FIX: locale-aware route so cart ops run in the visitor's market
        // context (was "/cart/update.js" -> updated cart in USD/primary market)
        const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: newQuantity } }),
        });
        const cart = await res.json();
        updateCartItemCounts(cart.item_count);
        // Update cart
        updateCartDrawer();
      });
    });
  document.querySelectorAll("button.quantity-remove").forEach((button) => {
    button.addEventListener("click", async () => {
      // Get line item key
      const rootItem = button.parentElement.parentElement.parentElement.parentElement;
      const key = rootItem.getAttribute("data-line-item-key");
      // Ajax update
      // FIX: locale-aware route (was "/cart/update.js")
      const res = await fetch(window.Shopify.routes.root + "cart/update.js", {
        method: "post",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ updates: { [key]: 0 } }),
      });
      const cart = await res.json();
      updateCartItemCounts(cart.item_count);
      // Update cart
      updateCartDrawer();
    });
  });
  document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
    e.stopPropagation();
  });
  document.querySelectorAll(".cart-drawer-close").forEach((el) => {
    el.addEventListener("click", () => {
      closeCartDrawer();
    });
  });
}
addCartDrawerListeners();
// MARKETS: $= (ends-with) so forms with locale-prefixed actions
// (e.g. /en-ca/cart/add) are still intercepted for AJAX add-to-cart
document.querySelectorAll('form[action$="/cart/add"]').forEach((form) => {
  form.addEventListener("submit", async (e) => {
    e.preventDefault();
    // Submit form with ajax
    // FIX: locale-aware route (was "/cart/add" -> created cart in
    // USD/primary market context, causing GBP page / USD drawer mismatch)
    await fetch(window.Shopify.routes.root + "cart/add", {
      method: "post",
      body: new FormData(form),
    });
    // Get cart count
    // FIX: locale-aware route (was "/cart.js")
    const res = await fetch(window.Shopify.routes.root + "cart.js");
    const cart = await res.json();
    updateCartItemCounts(cart.item_count);
    // Update cart
    await updateCartDrawer();
    // Open cart drawer
    openCartDrawer();
  });
});
// Open cart drawer
// MARKETS: $= (ends-with) so locale-prefixed cart links
// (e.g. /en-ca/cart) still open the drawer instead of navigating
document.querySelectorAll('a[href$="/cart"]').forEach((a) => {
  a.addEventListener("click", (e) => {
    e.preventDefault();
    openCartDrawer();
  });
});
jQuery(document).ready(function ($) {
  // Cart drawer upsell
  $(".cart-drawer-items").on("click", ".combo-box button", function (e) {
    e.preventDefault();
    var upsellId = $(this).closest(".upsell").data("upsell_id");
    // FIX: replaced CartJS.addItem (posts to unprefixed /cart/add.js,
    // same market-context bug) with a locale-aware fetch
    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ items: [{ id: upsellId, quantity: 1 }] }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error(res.status);
        return res.json();
      })
      .then(function () {
        return fetch(window.Shopify.routes.root + "cart.js");
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartItemCounts(cart.item_count);
        updateCartDrawer();
      })
      .catch(function (err) {
        console.log("Error: " + err + "!");
      });
  });
});
